import React, {useEffect} from "react";
import {Link} from "react-router-dom";
import './AnalizaMain.css'


export default function AnalizaMain(){

    useEffect(()=>{
        document.title="Analiza matematyczna";
    },[])


    return(
        <div className='conceptsContainer listOfButtons'>
            <Link to="/analiza/pojecia-wstepne" className='link'><button className='analizaLinks'>Pojęcia wstępne</button></Link>
            <Link to="/analiza/funkcja-jednej-zmiennej" className='link'><button className='analizaLinks'>Funkcja jednej zmiennej</button></Link>
            <Link to="/analiza/granice-funkcji" className='link'><button className='analizaLinks'>Granice funkcji</button></Link>
            <Link to="/analiza/pochodne" className='link'><button className='analizaLinks'>Pochodne</button></Link>
            <Link to="/analiza/liczby-zespolone" className='link'><button className='analizaLinks'>Liczby zespolone</button></Link>
            <Link to="/analiza/calki" className='link'><button className='analizaLinks'>Całki</button></Link>
            <br/><br/>
        </div>
    );
}